import styled from '@emotion/styled';
import React from 'react';
import { connect } from 'react-redux';

import CheckBox from '../../../shared/Checkbox';
import { BackArrow } from '../../../shared/svgIcons.jsx';
import TermsScrollBox from '../../../shared/terms';
import { incrementStep, decrementStep, setFormData } from '../../redux/actions';

const StepWrapper = styled.div`
  max-width: 23.125rem;
  width: 100%;
`;

const IntroMessage = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #333333;
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  text-transform: none;
`;

const NextButton = styled.button`
  background-color: #d40f7d;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 18px;
  padding: 0.5rem;
  width: 100%;
  margin-top: 1.5rem;

  :disabled {
    background-color: #d8d8d8;
    cursor: default;
  }
`;

const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;

  h3 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    text-transform: uppercase;
    font-family: 'OCRoboto';
  }
`;

const BackText = styled.p`
  margin-top: 0.5rem;
  padding-bottom: 1.5rem;
  text-align: center;
  font-size: 12px;
`;

const InputWrapper = styled.div`
  width: 100%;
  padding: 0.5em 0;
`;

const ScrollBox = styled.div`
  border: 1px solid #333333;
  padding: 1rem;
  height: 18rem;
  width: 23.125rem;
  overflow-y: scroll;
`;

const mapStateToProps = state => ({
  formData: state.formData,
});

const HomeownerStep14 = ({ incrementStep, decrementStep, formData }) => {
  const validated = formData.termsAndConditions;

  return (
    <StepWrapper>
      <BackWrapper
        data-track="form-back"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 15 - please read and accept our terms"
        onClick={decrementStep}
      >
        <BackArrow width="21" height="12" />
        <h3>Back</h3>
        <BackText>Please upload your proof of purchase.</BackText>
      </BackWrapper>
      <IntroMessage>Thanks for that!</IntroMessage>
      <Header>Please read and accept our terms of service before continuing.</Header>
      <InputWrapper>
        <TermsScrollBox />
      </InputWrapper>
      <InputWrapper>
        <CheckBox fieldKey="termsAndConditions" text="" noBorder>
          I agree to the{' '}
          <a href="https://www.owenscorning.com/en-us/terms-of-use" target="_blank" rel="noreferrer">
            terms & conditions
          </a>{' '}
          of the OWENS CORNING License and Services Agreement and I acknowledge that the OWENS CORNING{' '}
          <a href="https://www.owenscorning.com/en-us/privacy-policy" target="_blank" rel="noreferrer">
            Privacy Policy
          </a>{' '}
          was made available to me.
        </CheckBox>
      </InputWrapper>
      <InputWrapper>
        <CheckBox fieldKey="contactWithOffers" text="Yes! Contact me with exclusive offers." noBorder />
      </InputWrapper>
      <InputWrapper>
        <CheckBox fieldKey="includeRoofInDatabase" text="Include my roof in the shingle viewing database." noBorder />
      </InputWrapper>
      <InputWrapper>
        <CheckBox
          fieldKey="shareContactInformation"
          text="Share my contact information with members of our roofing contractor network."
          noBorder
        />
      </InputWrapper>
      <NextButton
        data-track="form-advance"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 15 - please read and accept our terms"
        onClick={incrementStep}
        disabled={!validated}
      >
        Next
      </NextButton>
    </StepWrapper>
  );
};

const mapDispatchToProps = dispatch => ({
  incrementStep: () => dispatch(incrementStep()),
  decrementStep: () => dispatch(decrementStep()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeownerStep14);
